// Which row actions an outgoing shipment permits — mirrors what the delete route itself rejects.

// Linked orders do NOT block a delete; the route drops those links itself.

// TODO: gate on a fulfil-request count once the list DTO exposes one — it sends only quantities.
const hasAllocations = (row) => Boolean(row?.hasAllocations);

export const OUTGOING_SHIPMENT_ACTIONS = Object.freeze({
  delete: { disabled: hasAllocations },
});
